export default __webpack_public_path__ + "static/media/user-settings.1ce6725e.svg";